import { of } from 'rxjs';
import { CanActivateFn } from '@angular/router';
import { extractTenantIdFromPath } from './tenant-id.util';

/**
 * Strips the {@code /app/{id}/} prefix from authenticated routes by forcing a
 * reload at the equivalent bare path. The prefix only exists to brand the
 * unauthenticated login screen (via the public branding endpoint); once the
 * user is authenticated all routes work under {@code /} so URLs like
 * {@code /dashboard}, {@code /users}, … stay clean and the multitenant filter
 * already scopes data by JWT.
 *
 * Use alongside {@code AuthGuard}; this guard does not check authentication.
 */
export const tenantIdGuard: CanActivateFn = () => {
  if (extractTenantIdFromPath(window.location.pathname) === null) {
    return of(true);
  }
  // Reload without the /app/{id}/ prefix; the rest of the path + query +
  // fragment is preserved so the user lands on the same screen, just clean.
  const strippedPath = window.location.pathname.replace(/^\/app\/[^/]+/, '') || '/';
  window.location.href = strippedPath + window.location.search + window.location.hash;
  return of(false);
};
